export default __webpack_public_path__ + "8f48d118a3be97214960bfafec117b32.svg";